import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useCallback, useMemo } from 'react'

import { updateFormDataField, useGetFormDataField } from 'cng-common/features/form'
import { IReportPeriod } from 'partner360/models/report/iReportPeriod'

import { SOB_ANALYTICS_REPORT_SETTINGS_FORM_KEY } from '../components/filters/configs'
import { IChangeSelectedModeFn, ReportViewModes } from '../components/reportViewSelector'

export const useReportViewSelector = () => {
  const dispatch = useAppDispatch()

  const [reportViewMode, handleChangeReportViewMode] = useGetFormDataField<ReportViewModes>(
    SOB_ANALYTICS_REPORT_SETTINGS_FORM_KEY,
    'reportViewMode'
  )

  const [reportViewPeriod, handleChangeReportViewPeriod] = useGetFormDataField<
    IReportPeriod | undefined
  >(SOB_ANALYTICS_REPORT_SETTINGS_FORM_KEY, 'reportViewPeriod')

  const onChangeReportViewState = useCallback<IChangeSelectedModeFn>(
    (newReportViewMode, newReportViewPeriod) => {
      handleChangeReportViewMode(newReportViewMode)
      handleChangeReportViewPeriod(newReportViewPeriod)

      if (newReportViewPeriod) {
        const quarters = newReportViewPeriod.Quarters.split(',').map((quarter) =>
          parseInt(quarter.slice(-1))
        )

        dispatch(
          updateFormDataField({
            formKey: SOB_ANALYTICS_REPORT_SETTINGS_FORM_KEY,
            field: 'submittedStatus',
            value: quarters[quarters.length - 1],
          })
        )
      }
    },
    [handleChangeReportViewMode, handleChangeReportViewPeriod, dispatch]
  )

  const selectedQuarters = useMemo(() => {
    if (!reportViewPeriod) {
      return []
    }

    return reportViewPeriod.Quarters.split(',').map((quarterTitle) =>
      parseInt(quarterTitle.slice(-1))
    )
  }, [reportViewPeriod])

  return {
    reportViewMode,
    reportViewPeriod,
    selectedQuarters,
    onChangeReportViewState,
  }
}
